import React from 'react';

const ImageProcessing = () => {
  const processingData = [
    { label: 'Images Uploaded', value: 1247, color: '#6c757d', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" ry="2" /><circle cx="9" cy="9" r="2" /><path d="M21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21" /></svg> },
    { label: 'Blurred Detected', value: 89, color: '#ffc107', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" /></svg> },
    { label: 'Background Removed', value: 234, color: '#dc3545', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 12l2 2 4-4" /><path d="M21 12c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z" /><path d="M3 12c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z" /><path d="M12 21c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z" /><path d="M12 3c.552 0 1-.448 1-1s-.448-1-1-1-1 .448-1 1 .448 1 1 1z" /></svg> },
    { label: 'Images Enhanced', value: 156, color: '#28a745', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" /></svg> }
  ];

  const maxValue = Math.max(...processingData.map(item => item.value));

  return (
    <div className="dashboard-card processing-card">
      <div className="card-body">
        <div className="card-header">
          <h3 className="card-title">Image Processing & AI Insights</h3>
          <p className="card-subtitle">AI-powered image enhancement statistics</p>
        </div>

        <div className="processing-chart">
          {processingData.map((item, index) => (
            <div key={item.label} className="processing-bar-container">
              <div className="processing-info">
                <div className="processing-icon">{item.icon}</div>
                <div className="processing-details">
                  <div className="processing-label">{item.label}</div>
                  <div className="processing-value">{item.value.toLocaleString()}</div>
                </div>
              </div>
              <div className="processing-bar-track">
                <div
                  className="processing-bar"
                  style={{
                    width: `${(item.value / maxValue) * 100}%`,
                    backgroundColor: item.color,
                    animationDelay: `${index * 0.2}s`
                  }}
                >
                  <div className="bar-glow"></div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="processing-summary">
          <div className="summary-stat">
            <span className="summary-label">Processing Rate</span>
            <span className="summary-value">94.2%</span>
          </div>
          <div className="summary-stat">
            <span className="summary-label">AI Accuracy</span>
            <span className="summary-value">97.8%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageProcessing;